import { components } from "@certn/api/generated-schemas/client-portal";
import {
  DropdownMenu,
  GhostIconButton,
  MenuItem,
  MenuSection,
  Text,
} from "@certn/cascadia-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { DeleteWebhookModal } from "./DeleteWebhookModal";
import { EditWebhookModal } from "./EditWebhookModal/Modal";
import { useVerifyWebhook } from "./verify";

interface Props {
  webhook: components["schemas"]["PublicAPIWebhookList"];
  onItemChanged: () => void;
}
export function ActionsDropdown({ webhook, onItemChanged }: Props) {
  const { t } = useTranslation();
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const { verify, isVerifying } = useVerifyWebhook(webhook.id, onItemChanged);

  return (
    <>
      <DropdownMenu
        triggerButton={
          <GhostIconButton
            testID="webhook-listing-item-expand"
            size="small"
            icon="more_horiz"
            aria-label={t("Expand menu")}
          />
        }
        onItemAction={(menuItem) => {
          switch (menuItem) {
            case "verify":
              if (!isVerifying) {
                verify();
              }
              break;
            case "edit":
              setShowEditModal(true);
              break;
            case "delete":
              setShowDeleteModal(true);
              break;
          }
        }}
        placement="bottom right"
      >
        <MenuSection>
          <MenuItem id="edit" testID="webhook-listing-edit">
            <Text style="input/text-field">{t("Edit")}</Text>
          </MenuItem>
          <MenuItem id="verify" testID="webhook-listing-verify">
            <Text style="input/text-field">
              {isVerifying ? t("Verifying...") : t("Verify")}
            </Text>
          </MenuItem>
          <MenuItem id="delete" testID="webhook-listing-delete">
            <Text style="input/text-field" color="text-danger">
              {t("Delete")}
            </Text>
          </MenuItem>
        </MenuSection>
      </DropdownMenu>
      <DeleteWebhookModal
        webhookId={webhook.id}
        onDeleted={onItemChanged}
        isOpen={showDeleteModal}
        onOpenChange={setShowDeleteModal}
      />
      <EditWebhookModal
        webhook={webhook}
        onSuccess={onItemChanged}
        isOpen={showEditModal}
        onOpenChange={setShowEditModal}
      />
    </>
  );
}
